import { createStore } from "redux";
import rootReducer from "./reducer/rootReducer";
import { persistStore, persistReducer } from "redux-persist";
import { encryptTransform } from "redux-persist-transform-encrypt";
import localStorage from "redux-persist/es/storage";

// import Test from "./pages/Test";

const encryptor = encryptTransform({
    secretKey: "root",
    onError: function (error) { },
});

const persistConfig = {
    key: "AyTbepliobWqqCxTYqa",
    storage: localStorage,
    transforms: [encryptor],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
let store = createStore(persistedReducer);
let persistor = persistStore(store);
export {
    persistor
}
export default store